import { render, staticRenderFns } from "./VirtualKeyboard65Fluffy.vue?vue&type=template&id=140243a1&scoped=true&"
import script from "./VirtualKeyboard65Fluffy.vue?vue&type=script&lang=js&"
export * from "./VirtualKeyboard65Fluffy.vue?vue&type=script&lang=js&"
import style0 from "./VirtualKeyboard65Fluffy.vue?vue&type=style&index=0&id=140243a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140243a1",
  null
  
)

export default component.exports